import { BackedApi } from "../../../../config/urls/Api"
import { PlanDto } from "./dto/plans.dto"

interface ResponsePlans {
    data: PlanDto[]
    error: boolean
    status: number
}

export class PlansRepository {
    static async list(): Promise<ResponsePlans> {
        const response = await fetch(BackedApi.ListPlans.url, {
            method: BackedApi.ListPlans.method,
            headers: {
                'Content-Type': 'application/json',
            },
        })
        const data = await response.json()
        const status = response.status
        return { data, error: status !== 200, status }
    }
}
